import React from 'react';

/** "Anotado: **R$ 38,00** em Alimentação" → text with the amount in bold. */
export const richText = (text: string): React.ReactNode =>
  text
    .split('**')
    .map((part, index) =>
      index % 2 === 1 ? <strong key={index}>{part}</strong> : part
    );

/** Amounts in the cards follow the visitor's language; the currency is BRL. */
export const formatBRL = (value: number, language: string): string =>
  new Intl.NumberFormat(language.startsWith('pt') ? 'pt-BR' : language, {
    style: 'currency',
    currency: 'BRL',
    currencyDisplay: 'narrowSymbol',
  }).format(value);
